import React, { useState, useEffect  } from 'react';
import { useApi } from '../../hooks/useApi'

import {  Card, CardHeader, Chip, IconButton, Stack, Skeleton, Typography } from '@mui/material'
import TrainingImage from "../../media/Lamp Poses-05-1.png"
import { Link } from 'react-router-dom'; 
function TileTrainingCenter ({ account }) {

    const jApi = useApi();
    const [badge, setBadge] = useState(0)
    const [badgeColor, setBadgeColor] = useState("error")
    const [ohSnap, setOhSnap] = useState(false)

    const [isLoading, setIsLoading] = useState(true)
    const fetchData = (async () => {
        try {
            setIsLoading(true)
            setOhSnap(false)
            setBadge(-1)
            const url = 'knowbe4/'+account+'/training_campaigns'
            const response = await jApi.request('GET', url);
            var currentDate = new Date();
            var year = currentDate.getFullYear();
            var monthNames = ["January", "February", "March", "April", "May", "June",
                              "July", "August", "September", "October", "November", "December"];
            var monthName = monthNames[currentDate.getMonth()];

            const monthly_training = `${monthName} ${year} Monthly Training`

            const item = response.data.find(obj => obj.name === monthly_training);

            
            if(item){
                setBadge(item.completion_percentage + '%')
                if(parseInt(item.completion_percentage) <= 69){
                    setBadgeColor("error")
                }                
                if (parseInt(item.completion_percentage) >= 70 && parseInt(item.completion_percentage) <= 89) {
                    setBadgeColor("warning");
                }
                if( 90 <=  parseInt(item.completion_percentage)){
                    setBadgeColor("primary")
                }

            }
            else {
                setBadge(0 + '%')
            }

        } catch (ex) {
            if(ex.response.data.error.message){
                if(ex.response.data.error.message.toLowerCase().includes("missing api key")){
                    setOhSnap(true)
                } else {
                    setBadge(0 + '%')
                }
            } else {
                setBadge(0 + '%')
            }            
            
        } finally {
            setIsLoading(false)
        }
    });


    useEffect(() => {
        fetchData(); 
    }, [account]); 


    return(
      <>
      
        <Card elevation={3}>
            <CardHeader  component={Link} to="/training" sx={{textDecoration: 'none'}}
                avatar={
                    
                  <IconButton edge="end" color="inherit" aria-label="logo" disableFocusRipple={true} disableRipple>
                  <img
                    width="60"
                    height="60"
                    src={TrainingImage}
                    alt="Logo"
                  />
                  </IconButton>
                  
                }
                title={
                    
                    <Typography component="h6" variant="h6" sx={{textDecoration: 'none', color: (theme) => theme.palette.secondary.main}}>
                        Training Center
                    </Typography>

                }
                subheader={
                    <>
                    {isLoading ? 
                        <Skeleton width="80%"></Skeleton>
                        
                        : 


                    <Stack direction="row" spacing={1} >

                        {!ohSnap ? 
                        <>
                            {badge === -1 ? <Skeleton variant="circular" width={20} height={20} /> : 
                            <Chip label={badge} color={badgeColor} size="small" />}
                            <Typography variant="subheading1" > complete this month.</Typography>
                        </>
                        :
                         <Typography variant="subheading1">Security training not configured.</Typography>
                        }
                    </Stack>
                    }
                    </>
                }
            />
        </Card>

        </>
    )
}


export default TileTrainingCenter